import React from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { Project } from '@leverege/api-redux';
import { AttributeDetailRenderer, ValueText, Attributes, InlineEditor } from '@leverege/ui-attributes';
import Path from '@leverege/path';
import { ValueCache } from '@leverege/value-cache';
import { jsx as _jsx } from "react/jsx-runtime";
const pathToEnumType = Path('blueprint/attribute/model/enumType');
const pathToProjectId = Path('data/projectId');
export default class EnumDetailRenderer extends AttributeDetailRenderer {
  constructor(detail) {
    super(detail);
    this.enumCache = new ValueCache();
  }

  /**
   * Gets the enum type from the attribute
   */
  getEnumType(object) {
    if (!this.enumType) {
      const attr = Attributes.getAttribute(this.detail.attrName, object.type);
      this.enumType = pathToEnumType.get(attr, null);
    }
    return this.enumType;
  }

  /**
   * Gets the enum data for the current type of enum
   */
  getEnumData(object) {
    const enumType = this.getEnumType(object);
    const projectId = pathToProjectId.get(object);
    if (enumType && projectId) {
      return Project(projectId).enum(enumType).getEnum(GlobalState.get());
    }
    return null;
  }

  /**
   * Gets the data for the value entry in the relevant  enum
   */
  getEnumValueData(value, object) {
    const enumData = this.getEnumData(object);
    const getValue = (data, value) => data.values.find(v => v.value === value);
    return this.enumCache.calc(getValue, enumData, value);
  }

  /**
   * Gets the value component.
   */
  getValueComponent(value, valueStyle, object, cxt, {
    valueVariant
  }) {
    const {
      editable
    } = cxt;
    const context = {
      ...cxt,
      renderer: this,
      target: [object]
    };
    const firstValue = value?.[0];
    const enumValue = this.getEnumValueData(firstValue, object);
    const displayValue = enumValue?.name || firstValue;
    return /*#__PURE__*/_jsx(InlineEditor, {
      usage: "detail",
      variant: valueVariant,
      editable: editable,
      attrName: this.name,
      object: object,
      style: valueStyle,
      context: context,
      children: /*#__PURE__*/_jsx(ValueText, {
        variant: valueVariant,
        style: valueStyle,
        children: displayValue
      })
    });
  }
}